import { render } from "./SiteHeroDefault.vue?vue&type=template&id=350e3b50&scoped=true"
import script from "./SiteHeroDefault.vue?vue&type=script&lang=js"
export * from "./SiteHeroDefault.vue?vue&type=script&lang=js"

import "./SiteHeroDefault.vue?vue&type=style&index=0&id=350e3b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350e3b50"]])

export default __exports__